export default {"src":"/_next/static/image/public/images/ic_return_policy_white_vertical_menu.58d8dcf803695922abf4890e7f1ba2a7.svg","height":20,"width":20};